import { Instagram, Facebook } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

interface SocialButtonProps {
  platform: 'instagram' | 'facebook';
  href: string;
  compact?: boolean;
}

const SocialButton = ({ platform, href, compact = false }: SocialButtonProps) => {
  const { t } = useLanguage();
  
  const config = {
    instagram: {
      icon: Instagram,
      label: t.visitInstagram,
    },
    facebook: {
      icon: Facebook,
      label: t.visitFacebook,
    },
  };

  const { icon: Icon, label } = config[platform];

  if (compact) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${label} (opens in new tab)`}
        className="p-2 text-muted-foreground hover:text-foreground transition-colors duration-200"
      >
        <Icon className="w-4 h-4" strokeWidth={1.5} aria-hidden="true" />
      </a>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${label} (opens in new tab)`}
      className="group flex items-center gap-4 px-8 py-4 border border-primary/15 bg-transparent hover:bg-primary hover:border-primary transition-all duration-300 ease-out"
    >
      <Icon 
        className="w-5 h-5 text-primary group-hover:text-primary-foreground transition-colors duration-300" 
        strokeWidth={1.5}
        aria-hidden="true"
      />
      <span className="font-sans text-sm tracking-widest uppercase text-primary group-hover:text-primary-foreground transition-colors duration-300">
        {label}
      </span>
    </a>
  );
};

export default SocialButton;
